import type { NodeDef, Edge } from '../types';

/**
 * When a workflow omits `transitions`, the builder synthesises a
 * linear chain from `nodes[0]` to `nodes[n-1]` in array order.
 */
export function synthesiseLinearChain(nodes: NodeDef[]): Edge[] {
  const edges: Edge[] = [];
  for (let i = 0; i < nodes.length - 1; i++) {
    edges.push({ from: nodes[i].name, to: nodes[i + 1].name });
  }
  return edges;
}
